import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';

export enum SituationReportBillsToPay {
  open = 'OPEN',
  settled = 'SETTLED',
}

export enum FilterByDateByReportBillsToPay {
  emission = 'EMISSION',
  expiration = 'DUE',
  payment = 'PAY',
}

export enum ReportTypeReportBillsToPay {
  emission = 'EMISSION',
  expiration = 'DUE',
  payment = 'PAY',
  accountPlans = 'PLAN_ACCOUNT',
  accountPlansSynthetic = 'PLAN_ACCOUNT_SYNTHETIC',
  bankAccount = 'BANK_ACCOUNT',
}

export enum ReportSortTypeEnum {
  Date = 'DATE',
  Description = 'DESCRIPTION',
  Debtor = 'DEBTOR',
  Code = 'CODE',
  Plan_Account = 'PLAN_ACCOUNT',
  Document_Type = 'DOCUMENT_TYPE',
}

export interface ReportBillsToPayFormValues extends ReportDateInterface {
  planAccountIds?: number[];
  documentTypeIds?: number[];
  insurersIds?: number[];
  lsSituacao: string[];
  costCenterIds?: number[];
  customersIds?: number[];
  bankAccountIds?: number[];
  suppliersIds?: number[];
  employeesIds?: number[];
  dateType: FilterByDateByReportBillsToPay;
  reportSortType?: ReportSortTypeEnum;
  reportType: ReportTypeReportBillsToPay;
  synthetic?: boolean;
  landingPage?: boolean;
}

export interface ReportBillsToPayRequestQuery
  extends ReportBillsToPayFormValues {
  format: string;
}
